// Trie.js
// This file is used to create a search trie data structure
// See .../utilites/buildTrie.js and tokenmapping.ipynb to learn how to rebuild the trie given new prompts
class TrieNode {
  constructor() {
    this.children = {};
    this.isEndOfWord = false;
    this.info = null;
  }
}

class Trie {
  constructor() {
    this.root = new TrieNode();
  }

  getNode(prefix) {
    return this._getNode(prefix);
  }

  _getNode(prefix) {
    let currentNode = this.root;

    for (const char of prefix) {
      if (!currentNode.children[char]) {
        return null;
      }

      currentNode = currentNode.children[char];
    }

    return currentNode;
  }

  insert(phrase, info) {
    const tokens = phrase.split(/[\s,]+/);
    tokens.forEach((token) => {
      let currentNode = this.root;

      for (let i = 0; i < token.length; i++) {
        const char = token[i].toLowerCase();

        if (!currentNode.children[char]) {
          currentNode.children[char] = new TrieNode();
        }

        currentNode = currentNode.children[char];
      }

      if (!currentNode.info) {
        currentNode.info = [];
      }
      currentNode.info.push({ phrase, info });
    });
  }

  searchAllNodes(prefix) {
    const node = this.getNode(prefix);
    if (!node) {
      return [];
    }

    const phrases = [];
    const traverse = (currentNode) => {
      if (currentNode.info) {
        phrases.push(...currentNode.info);
      }

      for (const nextNode of Object.values(currentNode.children)) {
        traverse(nextNode);
      }
    };

    traverse(node);
    return phrases;
  }

  autoComplete(prefix) {
    if (prefix.length < 3) {
      return [];
    }

    const tokens = prefix.toLowerCase().split(' ');
    let results = new Set();

    let token = tokens[0];
    const phrases = this.searchAllNodes(token);
    // enumerate phrase with index

    for (const phrase of phrases) {
      // console.log (prefix)
      // console.log (phrase.info[0])
      if (phrase.info[0].includes(prefix)) {
        results.add(phrase);
      }
    }
    return Array.from(results);
  }

  serializeNode(node) {
    const children = {};

    for (const char in node.children) {
      children[char] = this.serializeNode(node.children[char]);
    }

    return { children, isEndOfWord: node.isEndOfWord, info: node.info };
  }

  serialize() {
    return this.serializeNode(this.root);
  }

  deserializeNode(data) {
    const node = new TrieNode();
    node.isEndOfWord = data.isEndOfWord;
    node.info = data.info;

    for (const char in data.children) {
      node.children[char] = this.deserializeNode(data.children[char]);
    }

    return node;
  }

  deserialize(data) {
    this.root = this.deserializeNode(data);
  }
}

export { Trie };
